import React, {useState, useEffect, useCallback, useRef} from 'react';
import {
    Container,
    Button,
    Grid,
    CircularProgress,
    TextField, FormControl,
} from '@mui/material';
import { Alert } from '@mui/material';
import {useParams, useHistory} from 'react-router-dom';
import {useForm, Controller} from 'react-hook-form';
import {EmailContentService} from '../shared/service';
import ValidationError from "../../shared/ValidationError";
import {ContentState, convertFromHTML, Editor, EditorState, RichUtils} from "draft-js";
import Prompt from "../../../customUtil/Prompt";

const EmailTemplateForm = () => {
    const methods = useForm();
    const {handleSubmit, control, setValue, errors} = methods;

    const [data, setData] = useState({});
    const [message, setMessage] = useState('');
    const [isReady, setIsReady] = useState(false);
    const [editorState, setEditorState] = useState(() =>
        EditorState.createEmpty()
    );
    const editor = useRef(null);
    const history = useHistory();
    const [block, setBlock] = useState(false);  
    const refSubmitButtom = useRef();
 
    const [triggerExit, setTriggerExit] = useState({
        onOk: false,
        path: ""
      });
      const [isVisibleDialog, setVisibleDialog] = useState(false);

    const handleGoToIntendedPage = useCallback(
        (location) => history.push(location),
        [history]
      );

    //   function usePrevious(value) {
    //     const ref = useRef();
    //     useEffect(() => {
    //       ref.current = value;
    //     });
    //     return ref.current;
    //   }

    //   const prevAmount = usePrevious(editorState);
    // useEffect(() => {
    //     if(prevAmount.editorState !== editorState) {
    //         setBlock(true);
    //     }
      
    // }, [editorState]);

      useEffect(() => {       
        const unblock = history.block((location) => {
          if (location.pathname !== `/gas/account-statements/${id}`) {
            if(block){
                setVisibleDialog(true);   
                setTriggerExit({...triggerExit, path: location.pathname});
            }else{
                setVisibleDialog(false);   
                setTriggerExit({onOk: true, path: location.pathname});
            }
                           
              }
         
          if (triggerExit.onOk) {
            return true;
          }
          return false;
        });
        if (triggerExit.onOk) {
            handleGoToIntendedPage(triggerExit.path);
          }
        return () => {
          unblock();
        };
      }, [history, triggerExit.onOk, triggerExit.path, block]);

    const handleKeyCommand = (command, editorState) => {
        const newState = RichUtils.handleKeyCommand(editorState, command);

        if (newState) {
            setEditorState(newState);
            return 'handled';
        }

        return 'not-handled';
    }

    const {id} = useParams();


    useEffect(() => {
        if (id !== "new") {
            EmailContentService.getById(id).then((response) => {
                setData(response.data);
                setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(response.data.emailBody))));
                setIsReady(true);
            });
        } else {
            setData({countryPeople: []});
            setIsReady(true);
        }
    }, [id, setValue]);


    const onSubmit = d => {
        setBlock(false);
        setVisibleDialog(false);
        if (data.id) {
            EmailContentService.update({...data, emailBody: editor.current.editor.innerHTML}).then((response) => {
                setMessage('Template updated.')
            });
        } else {
            EmailContentService.create({...data, emailBody: editor.current.editor.innerHTML}).then((response) => {
                setData(response.data);
                setMessage('Template Created.');
            });
        }
    };

    if (!isReady) {
        return (
            <CircularProgress/>
        );
    }
    const triggerSubmit = () => {
        refSubmitButtom?.current?.click();
      };     
   
      const onSave = (event) => {
          console.log(event)
          triggerSubmit();
          setBlock(false);
          setVisibleDialog(false);
      }
  
      const checkModified = (event) => {
          if(event.type ===  "change"){
              setBlock(true);
                 }
              }

    return (
        <Container>
            <header>
                <h1>Email Template Form</h1>
            </header>
            {
                message && <Alert severity="success">{message}</Alert>
            }
             <form style={{textAlign: 'left'}} onSubmit={handleSubmit(onSubmit)} onChange={event => {checkModified(event)}}>
            <Prompt
               visible={isVisibleDialog}
               onClose={() => setVisibleDialog(false)}
               onOk={() => {
               setTriggerExit({...triggerExit, onOk: true});
               setVisibleDialog(false);
               setBlock(false);
            }}
               onSave={onSave}
            />
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <p>
                            Edit email template here.
                        </p>
                    </Grid>

                    <Grid item xs={6}>
                        <Controller
                            name="name"
                            control={control}
                            disabled
                            fullWidth
                            as={<TextField></TextField>}
                            label="Name"
                            color="primary"
                            variant="outlined"
                            defaultValue={data.emailTemplate && data.emailTemplate.templateName}
                        />
                        <ValidationError error={errors.name}/>
                    </Grid>

                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <Controller
                            name="language"
                            control={control}
                            disabled
                            fullWidth
                            as={<TextField></TextField>}
                            label="Language"
                            color="primary"
                            variant="outlined"
                            defaultValue={data.language && data.language.name}
                        />
                    </Grid>

                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={12}>
                        <br/>
                        <div className="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth">
                            <label
                                className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled"
                                data-shrink="true">Content</label>
                        </div>
                        <FormControl label="Content" variant="outlined">
                            <div
                                style={{border: "1px solid gray", minHeight: "6em", cursor: "text"}}
                                onClick={() => editor.current.focus()}>
                                <Editor
                                    ref={editor}
                                    handleKeyCommand={handleKeyCommand}
                                    editorState={editorState}
                                    onChange={setEditorState}
                                    placeholder="Type Content Here"
                                />
                            </div>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <Button variant="contained" color="primary" type="submit">Submit</Button>
                    </Grid>
                </Grid>
                <button hidden={true} ref={refSubmitButtom} type={"submit"} />
            </form>
        </Container>
    );
};

export default EmailTemplateForm;
